import React from "react";
import ProjectCard from "../components/ProjectCard";
import { projects } from "../lib/data";

function ProjectsSection() {
  return (
    <div className="flex flex-col gap-6">
      <div className="opacity-0-start animate-fade-in-d1">
        <h2 className="text-xl font-bold mb-1">Projects</h2>
        <p className="text-base text-content-muted">
          Click a card to visit the project
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {projects.map((p, i: number) => (
          <ProjectCard
            key={p.title}
            title={p.title}
            tech={p.tech}
            desc={p.desc}
            link={p.link}
            animationClass={`animate-fade-in-d${Math.min(i + 2, 5)}`}
          />
        ))}
      </div>
    </div>
  );
}

export default ProjectsSection;